/**
 * Type: コンポーネント
 * What: フッター
 */
import React from 'react';
import { Link, StaticQuery, graphql } from 'gatsby';
import { animateScroll as scroll } from 'react-scroll';
import Image from '../util/Image';
import { FOOTER_LINKS } from '../config/Links';
import '../sass/components/_footer.scss';

export const List = (props) => (
  <>
    {props.target ? (
      <a
        href={props.link}
        className={props.bold ? 'fwb' : ''}
        target="_blank"
        rel="noopener noreferrer"
      >
        {props.pageName}
      </a>
    ) : (
      <Link to={props.link} className={props.bold ? 'fwb' : ''}>
        {props.pageName}
      </Link>
    )}
  </>
);

const scrollToTop = (e) => {
  e.preventDefault();
  scroll.scrollToTop();
};

export const Title = (props) => {
  const PC = props.mq;
  return (
    <>
      <svg
        width="400"
        height={PC ? 80 : 40}
        viewBox={`0 0 400 ${PC ? 80 : 40}`}
      >
        <text
          className="medium en2"
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="central"
          letterSpacing="4"
        >
          {props.children}
        </text>
        <text
          className="foreground en2"
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="central"
          letterSpacing="4"
        >
          {props.children}
        </text>
      </svg>
    </>
  );
};

const Footer = (props) => {
  const PC = props.mq('pc');
  return (
    <StaticQuery
      query={graphql`
        query {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={() => (
        <>
          <div className={`scroll-top ${props.amount < 900 ? 'fadeOut' : ''}`}>
            <a href="/" onClick={scrollToTop} className="page-top en">
              <span>
                <Image
                  src="icon-arrow.svg"
                  alt="SCROLL TO TOP"
                  width="36px"
                  height="100px"
                />
              </span>
              <span className="scroll-text en2">SCROLL TO TOP</span>
            </a>
          </div>

          <footer className="footer">
            <div className="footer-inner">
              <div className="footer-left">
                <div className="footer-box">
                  <h1>
                    <Link to="/">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 150.18 122.45"
                      >
                        <g>
                          <path
                            className="cls-1"
                            d="M4.75,66.23v6a.51.51,0,0,0,.51.51h8.61a.5.5,0,0,1,.5.51v2.14a.5.5,0,0,1-.5.51H5.26a.5.5,0,0,0-.51.5v8.77a.51.51,0,0,1-.51.51H1.75a.51.51,0,0,1-.51-.51V63.08a.51.51,0,0,1,.51-.51H15.52a.51.51,0,0,1,.51.51v2.14a.51.51,0,0,1-.51.51H5.26a.51.51,0,0,0-.51.5"
                          />
                          <path
                            className="cls-1"
                            d="M28.81,85.91c-4.71,0-8.29-3.21-8.29-8V63a.47.47,0,0,1,.46-.46h2.59A.46.46,0,0,1,24,63V77.76c0,3.08,1.89,5,4.78,5s4.81-1.92,4.81-5V63a.47.47,0,0,1,.46-.46h2.6a.46.46,0,0,1,.45.46V77.92c0,4.78-3.61,8-8.32,8"
                          />
                          <path
                            className="cls-1"
                            d="M57.57,85.46l-6.25-11a.15.15,0,0,0-.25,0l-3.69,4.43a.26.26,0,0,0-.07.19v6.11a.51.51,0,0,1-.51.51H44.31a.51.51,0,0,1-.51-.51V63.08a.51.51,0,0,1,.51-.51H46.8a.51.51,0,0,1,.51.51v10.7a.15.15,0,0,0,.27.1l9-11.12a.49.49,0,0,1,.39-.19h3a.51.51,0,0,1,.39.84l-6.75,8.15a.17.17,0,0,0,0,.18L61.39,85a.51.51,0,0,1-.44.77H58a.5.5,0,0,1-.44-.26"
                          />
                          <path
                            className="cls-1"
                            d="M123.3,85.46l-6.25-11a.15.15,0,0,0-.25,0l-3.69,4.43a.32.32,0,0,0-.07.19v6.11a.5.5,0,0,1-.5.51H110a.51.51,0,0,1-.51-.51V63.08a.51.51,0,0,1,.51-.51h2.5a.5.5,0,0,1,.5.51v10.7a.15.15,0,0,0,.27.1l9-11.12a.51.51,0,0,1,.4-.19h3a.51.51,0,0,1,.39.84l-6.76,8.15a.17.17,0,0,0,0,.18L127.12,85a.51.51,0,0,1-.43.77h-3a.51.51,0,0,1-.44-.26"
                          />
                          <path
                            className="cls-1"
                            d="M73.81,85.91c-4.71,0-8.29-3.21-8.29-8V63a.47.47,0,0,1,.46-.46h2.6A.46.46,0,0,1,69,63V77.76c0,3.08,1.89,5,4.78,5s4.81-1.92,4.81-5V63a.47.47,0,0,1,.46-.46h2.6a.46.46,0,0,1,.45.46V77.92c0,4.78-3.61,8-8.32,8"
                          />
                          <path
                            className="cls-1"
                            d="M101.79,83.44a8.76,8.76,0,0,1-12.19,0c-2.27-2.27-2.24-4.84-2.24-9.29s0-7,2.24-9.3a8.76,8.76,0,0,1,12.19,0c2.28,2.28,2.22,4.84,2.22,9.3s.06,7-2.22,9.29M99.13,67a4.86,4.86,0,0,0-6.89,0c-1.14,1.24-1.37,2.54-1.37,7.19s.23,5.95,1.37,7.18a4.86,4.86,0,0,0,6.89,0c1.14-1.23,1.37-2.53,1.37-7.18s-.23-6-1.37-7.19"
                          />
                          <path
                            className="cls-1"
                            d="M145.85,85.38l-1.44-4.21a.15.15,0,0,0-.14-.1h-8.92a.16.16,0,0,0-.15.1l-1.44,4.21a.51.51,0,0,1-.48.34h-2.65a.5.5,0,0,1-.47-.68l8.11-22.13a.51.51,0,0,1,.48-.34h2.12a.51.51,0,0,1,.47.34L149.45,85a.5.5,0,0,1-.47.68h-2.65a.51.51,0,0,1-.48-.34m-6.11-17.16-3.39,9.66a.15.15,0,0,0,.14.2h6.7a.15.15,0,0,0,.14-.2L140,68.22a.16.16,0,0,0-.29,0"
                          />
                          <path
                            className="cls-2"
                            d="M67,16.85H61.32a.67.67,0,0,0-.53,1.09l5.66,7.18a.68.68,0,0,1,0,.83L60.81,33.1a.67.67,0,0,0,.53,1.09H67a.68.68,0,0,0,.53-.26l6.29-8a.68.68,0,0,0,0-.83l-6.31-8a.68.68,0,0,0-.53-.26"
                          />
                          <path
                            className="cls-2"
                            d="M55.72,16.85H50.09a.68.68,0,0,0-.53,1.09l5.66,7.18a.68.68,0,0,1,0,.83L49.58,33.1a.68.68,0,0,0,.53,1.09h5.63a.68.68,0,0,0,.53-.26l6.29-8a.68.68,0,0,0,0-.83l-6.31-8a.68.68,0,0,0-.53-.26"
                          />
                          <path
                            className="cls-2"
                            d="M44.49,16.85H38.86a.68.68,0,0,0-.53,1.09L44,25.12A.68.68,0,0,1,44,26L38.35,33.1a.68.68,0,0,0,.53,1.09h5.63a.68.68,0,0,0,.53-.26l6.29-8a.68.68,0,0,0,0-.83l-6.31-8a.68.68,0,0,0-.53-.26"
                          />
                          <path
                            className="cls-1"
                            d="M2.28,51.07H33.33A1.11,1.11,0,0,0,34.44,50V43.05a1.11,1.11,0,0,0-1.11-1.11H11.14a.55.55,0,0,1-.55-.55V30.25a.55.55,0,0,1,.55-.55H30.38a1.11,1.11,0,0,0,1.11-1.11v-6.4a1.11,1.11,0,0,0-1.11-1.11H11.21a.55.55,0,0,1-.55-.55V9.83a.56.56,0,0,1,.55-.56H33.33a1.11,1.11,0,0,0,1.11-1.11V1.55A1.11,1.11,0,0,0,33.33.44h-31A1.1,1.1,0,0,0,1.17,1.55V50a1.11,1.11,0,0,0,1.11,1.11"
                          />
                          <path
                            className="cls-1"
                            d="M76.72,8.91H95.43a.34.34,0,0,1,.29.51L75,43.29a1.06,1.06,0,0,0-.17.58V50a1.11,1.11,0,0,0,1.11,1.11h31A1.11,1.11,0,0,0,108,50V43.2a1.1,1.1,0,0,0-1.11-1.11H87.23a.34.34,0,0,1-.28-.51L107.84,7.64a1.1,1.1,0,0,0,.16-.58V1.55A1.1,1.1,0,0,0,106.89.44H76.72a1.1,1.1,0,0,0-1.11,1.11V7.8a1.11,1.11,0,0,0,1.11,1.11"
                          />
                          <path
                            className="cls-1"
                            d="M131.8,0a18.45,18.45,0,0,0-18.39,18.46V32.54c0,10.77,7.87,18.9,18.31,18.9,9.84,0,18.46-8.29,18.46-17.74V18.46A18.22,18.22,0,0,0,131.8,0m-8.9,18.46a8.81,8.81,0,0,1,9-9,8.93,8.93,0,0,1,7.65,4.23,8.38,8.38,0,0,1,1.24,3.53V32.54c0,5.44-3.88,9.55-9,9.55a9,9,0,0,1-8.82-9Z"
                          />
                          <path
                            className="cls-1"
                            d="M70,95.75c4.14,0,5.86,1.14,6.49,1.64s.75,2,.75,2.75a20.36,20.36,0,0,0,.23,2.33c.11.84-1.44,1.82-2.28-.2-1-2.44-2.41-3.89-5.07-3.93a2.94,2.94,0,0,0-3,2.74c.07,2.09,3,3.24,3.43,3.47.65.42,2.86,1.43,4.25,2.28,1.83,1.14,3.75,2.68,3.66,6.27-.09,4.34-2.78,7.35-8.36,7.25-3.78-.08-6.32-.82-7-1.95a24.43,24.43,0,0,1-.95-4.93c0-1.43,1.58-1.56,2.18-.32,1.29,2.62,3.19,4.38,6,4.59a3.23,3.23,0,0,0,3.59-3.08c-.06-1.91-1.5-2.58-4.15-3.93-3.4-1.77-7.21-3.29-7.14-8.21.08-5.59,4.63-6.75,7.37-6.77"
                          />
                          <path
                            className="cls-1"
                            d="M52.1,95.75c4.14,0,5.86,1.14,6.49,1.64s.76,2,.76,2.75a22.75,22.75,0,0,0,.22,2.33c.13.84-1.44,1.82-2.27-.2-1-2.44-2.42-3.89-5.07-3.93a2.94,2.94,0,0,0-3,2.74c.06,2.09,3,3.24,3.41,3.47.67.42,2.88,1.43,4.26,2.28,1.83,1.14,3.74,2.68,3.67,6.27-.1,4.34-2.78,7.35-8.37,7.25-3.78-.08-6.31-.82-7-1.95a24.43,24.43,0,0,1-1-4.93c0-1.43,1.59-1.56,2.19-.32,1.3,2.62,3.18,4.38,6,4.59A3.23,3.23,0,0,0,56,114.66c0-1.91-1.49-2.58-4.13-3.93-3.42-1.77-7.23-3.29-7.15-8.21.07-5.59,4.64-6.75,7.37-6.77"
                          />
                          <path
                            className="cls-1"
                            d="M.86,96.31c1.07-.07,3.3,0,5.51-.08s4.28-.17,5.47-.16c2.37,0,5.77,1.34,6,5.36.14,3.21-2,4.33-3.29,5.12-.13.09-.15.21.06.26a6,6,0,0,1,4.77,6.11c-.1,5-3.61,7.19-7.49,7.15-1.92,0-4-.27-5.54-.26-2.78,0-5,0-5.41,0-1.14-.06-1.23-1.56-.15-2.07,1.45-.68,1.56-1.15,1.56-1.47,0-.75.06-14.7.06-14.7s-.06-1-.15-1.94c-.06-.6-.61-1-1.47-1.34a1,1,0,0,1,.1-2m6.9,8.94c0,.38,0,.41.33.42,2.9.16,4.12-.68,4.18-3.48a3,3,0,0,0-3-3.42A1.26,1.26,0,0,0,7.78,100a51.82,51.82,0,0,0,0,5.28m0,4.17c0,.28,0,3.81,0,4.87,0,2.35.89,2.58,2.45,2.82.78.13,3.4-.48,3.35-4.09s-2.82-4.15-5.49-3.91a.31.31,0,0,0-.29.31"
                          />
                          <path
                            className="cls-1"
                            d="M31.88,95.81c6.13,0,11.08,4.65,11.08,12,0,7.94-4.73,12.49-11.08,12.49s-11.13-4.16-11.13-12.49c0-6.82,4-12,11.13-12m-5.44,11.91c0,5.75,1.47,9.75,5.48,9.75,3.64,0,5.23-4.62,5.23-9.75,0-4.93-1.86-9.09-5.23-9.09-3.07,0-5.48,3.36-5.48,9.09"
                          />
                          <path
                            className="cls-1"
                            d="M89.09,103.64a9.24,9.24,0,0,1,1.24-1,.37.37,0,0,1,.38.25,2.81,2.81,0,0,1,.11,1.26c-.24.78-1.21,1.17-1.27,2a.38.38,0,0,1-.22.19.28.28,0,0,1-.27-.19c-.09-.62-.19-1.25-.27-1.86a1,1,0,0,1,.3-.62m-4.14,12c-.82-.28-2-.63-2.13-1.68a15.1,15.1,0,0,1-.08-2.86.42.42,0,0,1,.28-.38,11.07,11.07,0,0,1,3.12-.51c.19.09.28.31.4.48.35.65.6,1.35.9,2,.24.27.65.11.92,0,.6-.29,1.15-.47,1.78-.72,0-.08.2-.14.12-.25a2.33,2.33,0,0,1-.44-1.4c0-.22,0-.47.24-.57s.46-.15.51-.39a.35.35,0,0,0-.07-.33c-.4-.45-1.58-.33-1.26-1.22.27-.24.64,0,.94-.16a1.08,1.08,0,0,1,.76-.46,4.73,4.73,0,0,1,2,.57.46.46,0,0,1,.12.4c-.27.36-.79.24-1.21.34a.34.34,0,0,0-.18.31.34.34,0,0,0,.26.29,24.11,24.11,0,0,1,2.88.92,1.79,1.79,0,0,1,.89,1.64.29.29,0,0,1-.17.23c-.56.07-.89-.49-1.46-.3-.43,0-.84.21-1.27.21l0,.11c-1.67,1.05-3.35,2.12-5,3.16a4,4,0,0,1-2.79.51m9.37-12.54c.57-.13,1.29-.69,1.88-.15.26.16.62.38.6.73-.11.16-.39.08-.54,0-1-.26-1.78.47-2.77.31-.3-.09-.65,0-.89-.27a4.09,4.09,0,0,1-.92-2,.33.33,0,0,1,.18-.28c.31,0,.49.26.78.29a1.05,1.05,0,0,0,.7,0c1-.23,2.23-1,3.22-.19l.5.33c.08.11.24.17.2.34-.39.35-.86,0-1.31,0a1.54,1.54,0,0,0-1.48.49c-.07.1-.23.25-.15.37m.33,2.2a1.57,1.57,0,0,1-1-.53.2.2,0,0,1,.15-.22c.9-.11,1.76-.36,2.66-.48l.07,0c.07.1,0,.24,0,.34a2.89,2.89,0,0,1-1.82.85m1.49,4.81c0,.12-.1.25-.22.27s-.28-.32-.42-.47a12.75,12.75,0,0,0-1.94-2.72c0-.07-.06-.21,0-.27.28,0,.5.18.72.35a5.45,5.45,0,0,1,1.85,2.84m10.91,4.05c-.94,1-1.84,2-2.8,3.07a3.55,3.55,0,0,1-1.63.79,28.06,28.06,0,0,0-2.46,2.91l-1,1.38a.55.55,0,0,1-.47.11c-.3-.19-.42-.53-.67-.78a19.91,19.91,0,0,0-2.75-3.14,4.62,4.62,0,0,0-3.1-1A2.07,2.07,0,0,1,90.5,116a.24.24,0,0,1,.19-.27,17.58,17.58,0,0,0,1.78.38,3.11,3.11,0,0,0,1.29-.32c.94-.49,1.86-1,2.82-1.52a5.35,5.35,0,0,1,1.78,0,1.5,1.5,0,0,0,.83-.37l2.58-2.5.81-.89a.32.32,0,0,1,.49.2,6.58,6.58,0,0,1-.8,2.33,18,18,0,0,0-1.2,2.79.69.69,0,0,0,0,.49.23.23,0,0,0,.32,0l.13-.08,2.74-2.72a1.64,1.64,0,0,1,.86-.55c.48.17,1-.27,1.45.06a1.73,1.73,0,0,1,.62.49.57.57,0,0,1-.14.56m-7.71-9.88s.1.06.1.11c0,.2-.18.22-.29.29a2.53,2.53,0,0,1-1.61-.32c-.07,0-.06-.16,0-.23l.1-.06c.56.09,1.17.12,1.74.21m-1.54-.75c0-.14.17-.18.27-.22l1.2-.44a.14.14,0,0,1,.18.11v.15a1.6,1.6,0,0,1-1.43.56c-.07,0-.16-.07-.21-.16m8,7.81a6.29,6.29,0,0,1-1.41.83c-.25,0-.25-.28-.34-.43l-.27-1.93a.42.42,0,0,1,.16-.33c.22-.16.47,0,.71,0,1,0,1.77-1,2.24-1.77a7.36,7.36,0,0,0,.53-3.71,1,1,0,0,0-.36-.54c-.84-.27-1.43.51-2,1.07a13,13,0,0,0-1.69,2.34.64.64,0,0,1-.58.17.87.87,0,0,1-.31-.47c-.11-.77-.29-1.52-.34-2.32,0-1,.88-1.74,1-2.75a20.75,20.75,0,0,0-.85-2.56,2.61,2.61,0,0,0-.77-1.18c-1.41-.65-3.05-1.39-4.66-.91-1.95.62-3.83,1.42-5.74,2.12a.43.43,0,0,1-.37-.07.25.25,0,0,1-.06-.31,13.93,13.93,0,0,1,2.06-3.27c1.1-.73,2.45-.7,3.76-.91a19,19,0,0,1,2.27.46,27.7,27.7,0,0,0,4.48.19,7.91,7.91,0,0,1,3,1.83,13.77,13.77,0,0,1,2.49,3c.7,1.75.52,3.81.62,5.76a6.7,6.7,0,0,1-.48,2.75,15.3,15.3,0,0,1-3.07,2.94m-.43-4.68c0,.46.26,1-.07,1.37a1.67,1.67,0,0,1-1,.49c-.34-.28,0-.75,0-1.12a7.17,7.17,0,0,1,1.27-2.62.78.78,0,0,1,.83-.27.45.45,0,0,1,.29.65c-.41.51-1.59.56-1.31,1.5"
                          />
                        </g>
                      </svg>
                    </Link>
                  </h1>
                  <p className="fz12">
                    <b>ボス イーゾ フクオカ</b>
                  </p>

                  <p className="fz13 footer-access">
                    <span>福岡市中央区地⾏浜2-2-6</span>
                  </p>
                  <ul className="sns">
                    <li className="cn-hide">
                      <a
                        href="https://twitter.com/EZOFUKUOKA"
                        className="tw"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Image
                          src="icon-tw.png"
                          alt="twitter"
                          target="_blank"
                          width="24px"
                          height="24px"
                        />
                      </a>
                    </li>
                    <li className="cn-hide">
                      <a
                        href="https://www.instagram.com/ezofukuoka/"
                        className="ig"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Image
                          src="ig.svg"
                          alt="instagram"
                          target="_blank"
                          width="26px"
                          height="28px"
                        />
                      </a>
                    </li>
                    <li className="cn-hide">
                      <a
                        href="https://www.youtube.com/channel/UCf_4SX2KMdo1ieafAj2vwLw"
                        className="yt"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Image
                          src="icon-youtube.svg"
                          alt="youtube"
                          target="_blank"
                          width="26px"
                          height="26px"
                        />
                      </a>
                    </li>
                  </ul>
                  {/*
                    <div className="footer-btn-wrap">
                      <Link to="/inquiry/group/" className="footer-btn footer-btn-ticket">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="31"
                          height="15"
                          viewBox="0 0 31 15"
                          className="footer-btn-icon"
                        >
                          <path
                            id="icon-ticket"
                            className="svg-ticket"
                            d="M130.307,10890h-5.269v0.9h-1.007v-0.9H105.936a0.688,0.688,0,0,0-.693.7v1.6h18.788v-0.5h1.007v0.5H126.9v9.3h3.41a0.688,0.688,0,0,0,.693-0.7v-3.3h-0.094a1.8,1.8,0,1,1,0-3.6H131v-3.3A0.688,0.688,0,0,0,130.307,10890Zm-5.243,3.4H119.8v0.9h-1.007v-0.9H100.693a0.688,0.688,0,0,0-.693.7v10.2a0.688,0.688,0,0,0,.693.7h18.1v-1.1H119.8v1.1h5.269a0.688,0.688,0,0,0,.693-0.7v-3.3h-0.093a1.8,1.8,0,1,1,0-3.6h0.093v-3.3A0.688,0.688,0,0,0,125.064,10893.4Zm-19.006,8.3H104.43a0.187,0.187,0,0,1-.152-0.3l1.629-2.1c0.056,0,.056-0.1,0-0.2l-1.635-2.1a0.187,0.187,0,0,1,.152-0.3h1.628a0.131,0.131,0,0,1,.152.1l1.824,2.3c0.056,0.1.056,0.2,0,.2l-1.818,2.4h-0.152Zm3.244,0h-1.628a0.187,0.187,0,0,1-.152-0.3l1.63-2.1c0.055,0,.055-0.1,0-0.2l-1.634-2.1a0.187,0.187,0,0,1,.151-0.3H109.3a0.131,0.131,0,0,1,.152.1l1.824,2.3c0.056,0.1.056,0.2,0,.2l-1.818,2.4H109.3Zm5.214-2.4-1.818,2.4h-1.78a0.187,0.187,0,0,1-.152-0.3l1.63-2.1c0.055,0,.055-0.1,0-0.2l-1.635-2.1a0.187,0.187,0,0,1,.151-0.3h1.628a0.131,0.131,0,0,1,.152.1l1.824,2.3C114.572,10899.2,114.572,10899.3,114.516,10899.3Zm5.279,3.8h-1.007v-2.1H119.8v2.1Zm0-2.9h-1.007v-2.1H119.8v2.1Zm0-2.9h-1.007v-2.1H119.8v2.1Z"
                            transform="translate(-100 -10890)"
                          />
                        </svg>
                        チケット購入・
                        <br className="enbr" />
                        団体予約
                      </Link>
                    </div>
                    */}
                  {/*
                    <div className="footer-btn-wrap">
                      <Link to="/inquiry/form/" className="footer-btn footer-btn-contact">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="17"
                          viewBox="0 0 21 17"
                          className="footer-btn-icon"
                        >
                          <path
                            id="icon-mail.svg"
                            className="svg-contact"
                            d="M118.9,10955H102.1a2.133,2.133,0,0,0-2.089,2.1L100,10969.9a2.143,2.143,0,0,0,2.1,2.1h16.8a2.143,2.143,0,0,0,2.1-2.1v-12.8A2.143,2.143,0,0,0,118.9,10955Zm0,14.9H102.1v-10.6l8.4,5.3,8.4-5.3v10.6Zm-8.4-7.5-8.4-5.3h16.8Z"
                            transform="translate(-100 -10955)"
                          />
                        </svg>
                        よくあるお問合せ
                      </Link>
                    </div>
                    */}
                </div>
              </div>
              <div className="footer-right">
                <div className="footer-list-wrap">
                  {PC && (
                    <>
                      <ul className="footer-list">
                        <li>
                          <p>フロアガイド</p>
                          <ul className="footer-list-children">
                            {FOOTER_LINKS.map((footerLink) => (
                              <li key={footerLink.link}>
                                <List {...footerLink} />
                              </li>
                            ))}
                          </ul>
                        </li>
                      </ul>
                      <ul className="footer-list">
                        <li>
                          <Link to="/access/">アクセス情報</Link>
                        </li>
                        <li>
                          <Link to="/news/">TOPICS</Link>
                        </li>
                        <li>
                          <Link to="/information/">施設案内</Link>
                          {/*
                            <ul className="footer-list-children">
                              <li>
                                <Link to="/information/">営業時間</Link>
                              </li>
                              <li>
                                <a href="/">ビル案内</a>
                              </li>
                              <li>
                                <a href="/">施設内設備</a>
                              </li>
                              <li>
                                <a href="/">サービス</a>
                              </li>
                              <li>
                                <a href="/">駐車場案内</a>
                              </li>
                            </ul>
                            */}
                        </li>
                        <li>
                          <Link to="/rule/">ご来館の皆様へ</Link>
                        </li>
                        <li>
                          <Link to="/group/">団体様ご利用案内</Link>
                        </li>
                        <li>
                          <Link to="/eventhall/">イベントホールご利用案内</Link>
                        </li>
                        <li>
                          <Link to="/inquiry/gakusai/">学園祭協賛について</Link>
                        </li>
                        <li>
                          <Link to="/tax-free/">免税手続きについて</Link>
                        </li>
                        <li>
                          <a
                            href="https://www.softbankhawks.co.jp/company/note_inquiry_coverage.html"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            取材に関するお問い合わせ
                          </a>
                        </li>
                      </ul>
                    </>
                  )}

                  <ul className="footer-list">
                    <li>
                      <a href="/inquiry/chat/">
                        お問合わせ
                        {!PC && <Image src="breadcrumb-arrow.svg" />}
                      </a>
                    </li>
                    <li>
                      <Link to="/ticket/how/">
                        チケット購入方法
                        {!PC && <Image src="breadcrumb-arrow.svg" />}
                      </Link>
                    </li>
                    <li>
                      <Link to="/schedule/">
                        施設の営業時間
                        {!PC && <Image src="breadcrumb-arrow.svg" />}
                      </Link>
                    </li>
                    <li>
                      <a
                        href="https://www.softbankhawks.co.jp/company/company_profile.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        企業情報
                        {!PC && <Image src="breadcrumb-arrow.svg" />}
                      </a>
                    </li>
                    <li className="sp">
                      <Link to="/eventhall/">
                        イベントホールご利用案内
                        {!PC && <Image src="breadcrumb-arrow.svg" />}
                      </Link>
                    </li>
                    <li className="sp">
                      <Link to="/inquiry/gakusai/">
                        学園祭協賛について
                        {!PC && <Image src="breadcrumb-arrow.svg" />}
                      </Link>
                    </li>
                    <li className="sp">
                      <Link to="/tax-free/">
                        免税手続きについて
                        {!PC && <Image src="breadcrumb-arrow.svg" />}
                      </Link>
                    </li>
                    <li className="sp">
                      <a
                        href="https://www.softbankhawks.co.jp/company/note_inquiry_coverage.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        取材に関するお問い合わせ
                        {!PC && <Image src="breadcrumb-arrow.svg" />}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.softbankhawks.co.jp/company/privacy.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        プライバシー
                        <br className="sp" />
                        ポリシー
                        {!PC && <Image src="breadcrumb-arrow.svg" />}
                      </a>
                    </li>
                    {/*
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer">
                          ソーシャルメディア
                          <br className="sp" />
                          ポリシー
                          { !PC && <Image src="breadcrumb-arrow.svg" /> }
                        </a>
                      </li>
                      */}
                    <li>
                      <a
                        href="https://www.softbankhawks.co.jp/company/policy.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        情報セキュリティポリシー
                        {!PC && <Image src="breadcrumb-arrow.svg" />}
                      </a>
                    </li>
                  </ul>
                </div>

                {PC && (
                  <div className="copy">
                    <p className="copy-text en">
                      2020 &copy; BOSS E・ZO FUKUOKA All RIGHTS RESERVED.
                    </p>
                  </div>
                )}
              </div>
            </div>

            {!PC && (
              <div className="copy">
                <p className="copy-text en">
                  2020 &copy; BOSS E・ZO FUKUOKA All RIGHTS RESERVED.
                </p>
              </div>
            )}
          </footer>
        </>
      )}
    />
  );
};

export default Footer;
